<template>

  <el-menu :unique-opened="true" :default-openeds="[menu[0]?.id]" @select="onSelect">
    <template v-for="item in menu">
    <SubMenu :data="item" :key="item.id"></SubMenu>
    </template>

  </el-menu>

</template>

<script>
import SubMenu from './sub-menu.vue';

export default {
  name: 'AutoMenu',
  components: {SubMenu},
  props: {
    menu: Array,
  },
  methods: {
    onSelect(data) {
      this.$emit('select', data);
    }
  }
}
</script>

<style lang="less">
.el-submenu__title {
  span {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
}
</style>